/**
 * Base URL for Hive property API calls.
 * The browser goes through our own proxy (src/api/hive), which adds the API key on the server.
 * Server-side code calls the API directly and must send the key itself (see hive-server.js).
 */
export const hiveApiUrl = () =>
	typeof window === "undefined" ? process.env.HIVE_API_URL : "/api/hive"
